<div [@routerTransition]>

  <div class="border-all-10px-modal">
    <div class="card col-md-12">
      <div class="card-header padding-left-15px">
        <div class="row">
          <div class="col-md-10 padding-left-0px">
            <label class="wh-header font-weight-normal padding-left-5px card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
              Customize Your Dashboard
            </label>            
          </div>

          <div class="col-md-2 padding-left-0px float-right">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>

      <div class="card-body padding-top-0px padding-right-0px padding-bottom-0px">
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-md-3 border-right-2px-gray">
            <div class="row">
              <label class="margin-bottom-0px font-size-16px font-weight-bold">Modules</label>
            </div>
            <div class="row border-bottom row-for-scans2 margin-left-0px margin-right-0px nav-link-hand padding-bottom-6px" *ngFor="let l of CurrentMisReportCategoriesController" (click)="ViewModuleWidgets(l)">

              <label class="margin-bottom-0px font-size-15px">{{l.ReportCategory}}</label>

            </div>

          </div>
          <div class="col-md-9 padding-left-0px padding-right-0px">
            <div class="">
              <div class="padding-right-0px background-white">
                <div class="">

                  <div class="card top-link">
                    <div class="card-header wh-header padding-bottom-0px padding-top-0px padding-left-0px">
                      <div class="row margin-left-0px">
                        <div class="col-md-10 padding-left-10px" *ngIf="SelectedModule">
                          <label class="margin-bottom-0px font-size-16px">{{SelectedModule.ReportCategory}}</label>
                        </div>


                      </div>

                    </div>

                    <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
                      <div class="chatsd product-chart-wrapper product-chat-height-400 agreement-chart-wrapper ps2 padding-lrt">
                        <div class="row">
                          <div class="col-md-12 padding-right-0px">
                            <div class="table-component">
                              <div class="table-responsive overflow-x">


                                <table class="table table-striped margin-left-zero"
                                       cols="auto,2*,*,*,*,*,*,*">

                                  <thead class="">
                                    <tr>
                                      <th class="">
                                        Feature
                                      </th>

                                      <th class="">
                                        Display Type
                                      </th>
                                      <th class="">
                                        Status
                                      </th>
                                      <th class="padding-left-0px">
                                        View
                                      </th>




                                    </tr>
                                  </thead>

                                  <tbody class="table-body">
                                    <tr *ngFor="let l of pdata">
                                      <td>
                                        <label class="margin-bottom-0px">{{l.ReportName}}</label>
                                      </td>
                                      <td class=" td-padding-tb">
                                        <label class="margin-bottom-0px">{{l.DisplayType}}</label>

                                      </td>
                                      <td>
                                        {{l.RecordStatus}}
                                      </td>
                                      <td class=" td-padding-tb">
                                        <input type="checkbox" [checked]="GetRecordStatus(l)"
                                                (change)="onSubmit(l, $event)" class="width-15px">
                                      </td>
                                      
                                    </tr>

                                  </tbody>

                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      
    </div>
  </div>



</div>
